import { configureStore } from '@reduxjs/toolkit';
import { digitalGalleryApi } from '../redux/api-slice';

export const store = configureStore({
    reducer: {
        [digitalGalleryApi.reducerPath]: digitalGalleryApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(digitalGalleryApi.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
